import { FunctionComponent, SVGProps } from "react";

export type IconProps = {
  icon: IconType;
  color?: string;
};

export type IconType = FunctionComponent<SVGProps<SVGSVGElement>> & {
  className: string;
};

const getColor = (color: string | undefined) => {
  if (!color) {
    return "inherit";
  }
  if (color.charAt(0) === "#") {
    return color;
  }
  return `#${color}`;
};

export const Icon: React.FC<IconProps> = ({ icon, color }) => {
  const Comp = icon;
  return <Comp className={icon.className} color={getColor(color)} />;
};

export default Icon;
